



















import { defineComponent, watch } from '@vue/composition-api';

export default defineComponent({
  name: 'OptionsMenu',
  props: {
    optionsTitle: {
      type: String,
      default: '',
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    function getTopPosition() {
      if (process.client) {
        const announcement = (document?.getElementsByClassName('announcement')[0] as HTMLElement)?.getBoundingClientRect();
        const navBar = document?.getElementsByTagName('header')[0]?.offsetHeight;
        const viewportHeight = window?.innerHeight;
        let visibleHeight = Math.min(announcement?.bottom, viewportHeight) - Math.max(announcement?.top, 0);

        visibleHeight = Math.max(visibleHeight, 0);
        return { top: `${visibleHeight + navBar}px` };
      }

      return { top: '72px' };
    }

    watch(() => props.isOpen, (isOpen) => {
      const body = document?.getElementsByTagName('BODY')[0] as HTMLElement;

      if (isOpen) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = 'scroll';
      }
    });

    return {
      getTopPosition,
    };
  },
});
